<div class="main-box">
  <div class="search-section">
    <div class="header-box d-flex flex-wrap w-100 justify-content-between row-gap-2">
      <div class="d-flex flex-wrap">
        <div class="back-btn" (click)="goBack()">
          <img class="back-btn-img" src="../../../assets/Krid/img/back-btn.svg" alt="" />
        </div>
        <h2 class="mt-2 mb-2 mx-2">
          <span class="cursor-pointer" (click)="goBack()">
            Claim Workflow &nbsp;</span>
          / Qualifying Expenditure by Cost Category
          <span mb-2 [ngClass]="{ 'locked-text ms-2 text-danger': isLocked }">{{
            +isLocked ? commonLabelConstants.Locked : ""
            }}</span>
          <span [title]="commonLabelConstants.ViewPermission" *ngIf="haveOnlyViewPermission">
            <i class="ms-2 fa fa-eye"> </i>
          </span>
        </h2>
      </div>
      <ng-select [ngClass]="getStatus(claimWorkFlowItemStatus)" [items]="claimWorkFlowItemStatusList"
        [disabled]="isLocked || haveOnlyViewPermission" [(ngModel)]="claimWorkFlowItemStatus"
        placeholder="Change status of form" bindLabel="value" bindValue="id" class="ms-2 w-200 claimWorkFlowStatus"
        (change)="claimWorkFlowItemStatusChange($event)">
        <ng-template ng-option-tmp let-item="item">
          <span title="{{ item.value }}">{{ item.value }}</span>
        </ng-template>
      </ng-select>
    </div>
  </div>
  @if(isDataAvailable == true){
  <mat-tab-group #tabGroup (selectedTabChange)="onTabChange($event)">
    <mat-tab label="Summary">
      <div class="d-flex flex-wrap justify-content-end">
        <button type="button" class="btn btn-primary-datalist me-3 mt-3 mb-3" (click)="export()">
          <i class="fa-solid fa-download"></i>
          <span class="hidebuttonName"> EXPORT</span>
        </button>
      </div>
      <!-- <ul class="summary-list">
        <li *ngIf="costCategoryRights.isStaffCostClaim" (click)="summaryClick('Staffing')"
          [ngClass]="expenditureCount.staffingCount > 0 ? '' : 'disabled'">
          <a>
            Staffing
            <span class="arrow"><i class="fa fa-arrow-right"></i></span>
          </a>
        </li>
        <li *ngIf="costCategoryRights.isUnconnectedContractorPerson"
          (click)="summaryClick('Externally Provided Workers - Unconnected')"
          [ngClass]="expenditureCount.unConnectedEPWCount > 0 ? '' : 'disabled'">
          <a>
            Externally Provided Workers - Unconnected
            <span class="arrow"><i class="fa fa-arrow-right"></i></span>
          </a>
        </li>
        <li *ngIf="costCategoryRights.isConnectedContractorPerson"
          (click)="summaryClick('Externally Provided Workers - Connected')"
          [ngClass]="expenditureCount.connectedEPWCount > 0 ? '' : 'disabled'">
          <a>
            Externally Provided Workers - Connected
            <span class="arrow"><i class="fa fa-arrow-right"></i></span>
          </a>
        </li>
        <li *ngIf="costCategoryRights.isUnconnectedRADContracted"
          (click)="summaryClick('Contracted Out R&D - Unconnected')" [ngClass]="
            expenditureCount.unConnectedSubContractorCount > 0 ? '' : 'disabled'
          ">
          <a>
            Contracted Out R&D - Unconnected
            <span class="arrow"><i class="fa fa-arrow-right"></i></span>
          </a>
        </li>
        <li *ngIf="costCategoryRights.isConnectedRADContracted" (click)="summaryClick('Contracted Out R&D - Connected')"
          [ngClass]="
            expenditureCount.connectedSubContractorCount > 0 ? '' : 'disabled'
          ">
          <a>
            Contracted Out R&D - Connected
            <span class="arrow"><i class="fa fa-arrow-right"></i></span>
          </a>
        </li>
        <li *ngIf="costCategoryRights.isSoftwareLicence" (click)="summaryClick('Software')" [ngClass]="
            expenditureCount.softwareLicenceCount > 0 ? '' : 'disabled'
          ">
          <a>
            Software
            <span class="arrow"><i class="fa fa-arrow-right"></i></span>
          </a>
        </li>
        <li *ngIf="costCategoryRights.isDataLicence" (click)="summaryClick('Data Licences')"
          [ngClass]="expenditureCount.dataLicenceCount > 0 ? '' : 'disabled'">
          <a>
            Data Licences
            <span class="arrow"><i class="fa fa-arrow-right"></i></span>
          </a>
        </li>
        <li *ngIf="costCategoryRights.isCloudComputing" (click)="summaryClick('Cloud Computing')"
          [ngClass]="expenditureCount.cloudComputingCount > 0 ? '' : 'disabled'">
          <a>
            Cloud Computing
            <span class="arrow"><i class="fa fa-arrow-right"></i></span>
          </a>
        </li>
        <li *ngIf="costCategoryRights.isUtility" (click)="summaryClick('Water, Fuel and Power')"
          [ngClass]="expenditureCount.utilityCount > 0 ? '' : 'disabled'">
          <a>
            Water, Fuel, and Power
            <span class="arrow"><i class="fa fa-arrow-right"></i></span>
          </a>
        </li>
        <li *ngIf="costCategoryRights.isConsumableItemsExcludingUtilities" (click)="summaryClick('Consumable Items')"
          [ngClass]="
            expenditureCount.consumableItemsCount > 0 ? '' : 'disabled'
          ">
          <a>
            Consumable Items
            <span class="arrow"><i class="fa fa-arrow-right"></i></span>
          </a>
        </li>
        <li *ngIf="costCategoryRights.isPaymentsToClinicalTrialParticipants"
          (click)="summaryClick('Payments to Clinical Trial Participants')" [ngClass]="
            expenditureCount.paymentsToClinicalTrialParticipantsCount > 0
              ? ''
              : 'disabled'
          ">
          <a>
            Payments to Clinical Trial Participants
            <span class="arrow"><i class="fa fa-arrow-right"></i></span>
          </a>
        </li>
      </ul> -->
      <div class="summary-list-table">
        <table class="table">
          <thead>
            <tr>
              <th>Expenditure</th>
              <th class="text-left">Total Qualifying Cost</th>
              <th class="action-btn">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="costCategoryRights.isStaffCostClaim">
              <td >
                <a (click)="summaryClick('Staffing')">
                  Staffing
                </a>
              </td>
              <td > <div class="amount">  £ {{ staffing | customCurrency : env.CurrencyFormat }} </div></td>
              <td class="action-btn" [ngClass]="expenditureCount.staffingCount > 0 ? '' : 'disabled'">
                <a (click)="summaryClick('Staffing')">
                  <span class="arrow"><i class="fa fa-arrow-right"></i></span>
                </a>
              </td>
            </tr>
            <tr *ngIf="costCategoryRights.isUnconnectedContractorPerson"
              >
              <td>
                <a (click)="summaryClick('Externally Provided Workers - Unconnected')">
                  Externally Provided Workers - Unconnected
                </a>
              </td>
              <td > <div class="amount">£ {{ epwUnconnected | customCurrency : env.CurrencyFormat }} </div></td>
              <td class="action-btn" [ngClass]="expenditureCount.unConnectedEPWCount > 0 ? '' : 'disabled'">
                <a (click)="summaryClick('Externally Provided Workers - Unconnected')">
                  <span class="arrow"><i class="fa fa-arrow-right"></i></span>
                </a>
              </td>
            </tr>
            <tr *ngIf="costCategoryRights.isConnectedContractorPerson"
              >
              <td>
                <a (click)="summaryClick('Externally Provided Workers - Connected')">
                  Externally Provided Workers - Connected
                </a>
              </td>
              <td > <div class="amount">£ {{ epwConnected | customCurrency : env.CurrencyFormat }} </div></td>
              <td class="action-btn" [ngClass]="expenditureCount.connectedEPWCount > 0 ? '' : 'disabled'">
                <a (click)="summaryClick('Externally Provided Workers - Connected')">
                  <span class="arrow"><i class="fa fa-arrow-right"></i></span>
                </a>
              </td>
            </tr>
            <tr *ngIf="costCategoryRights.isUnconnectedRADContracted"
              >
              <td>
                <a (click)="summaryClick('Contracted Out R&D - Unconnected')">
                  Contracted Out R&D - Unconnected
                </a>
              </td>
              <td > <div class="amount">£ {{ contractorUnconnected | customCurrency : env.CurrencyFormat }} </div></td>
              <td class="action-btn" [ngClass]="expenditureCount.unConnectedSubContractorCount > 0 ? '' : 'disabled'">
                <a (click)="summaryClick('Contracted Out R&D - Unconnected')">
                  <span class="arrow"><i class="fa fa-arrow-right"></i></span>
                </a>
              </td>
            </tr>
            <tr *ngIf="costCategoryRights.isConnectedRADContracted"
              >
              <td>
                <a (click)="summaryClick('Contracted Out R&D - Connected')">
                  Contracted Out R&D - Connected
                </a>
              </td>
              <td > <div class="amount">£ {{ contractorConnected | customCurrency : env.CurrencyFormat }} </div></td>
              <td class="action-btn" [ngClass]="expenditureCount.connectedSubContractorCount > 0 ? '' : 'disabled'">
                <a (click)="summaryClick('Contracted Out R&D - Connected')">
                  <span class="arrow"><i class="fa fa-arrow-right"></i></span>
                </a>
              </td>
            </tr>
            <tr *ngIf="costCategoryRights.isSoftwareLicence"
              >
              <td>
                <a (click)="summaryClick('Software')">
                  Software
                </a>
              </td>
              <td > <div class="amount">£ {{ software | customCurrency : env.CurrencyFormat }} </div></td>
              <td class="action-btn" [ngClass]="expenditureCount.softwareLicenceCount > 0 ? '' : 'disabled'">
                <a (click)="summaryClick('Software')">
                  <span class="arrow"><i class="fa fa-arrow-right"></i></span>
                </a>
              </td>
            </tr>
            <tr *ngIf="costCategoryRights.isDataLicence"
              >
              <td>
                <a (click)="summaryClick('Data Licences')">
                  Data Licences
                </a>
              </td>
              <td > <div class="amount">£ {{ dataLicnece | customCurrency : env.CurrencyFormat }} </div></td>
              <td class="action-btn" [ngClass]="expenditureCount.dataLicenceCount > 0 ? '' : 'disabled'">
                <a (click)="summaryClick('Data Licences')">
                  <span class="arrow"><i class="fa fa-arrow-right"></i></span>
                </a>
              </td>
            </tr>
            <tr *ngIf="costCategoryRights.isCloudComputing"
              >
              <td>
                <a (click)="summaryClick('Cloud Computing')">
                  Cloud Computing
                </a>
              </td>
              <td > <div class="amount">£ {{ cloudComputing | customCurrency : env.CurrencyFormat }} </div></td>
              <td class="action-btn" [ngClass]="expenditureCount.cloudComputingCount > 0 ? '' : 'disabled'">
                <a (click)="summaryClick('Cloud Computing')">
                  <span class="arrow"><i class="fa fa-arrow-right"></i></span>
                </a>
              </td>
            </tr>
            <tr *ngIf="costCategoryRights.isUtility" >
              <td>
                <a (click)="summaryClick('Water, Fuel and Power')">
                  Water, Fuel, and Power
                </a>
              </td>
              <td > <div class="amount">£ {{ waterFuelPower | customCurrency : env.CurrencyFormat }} </div></td>
              <td class="action-btn" [ngClass]="expenditureCount.utilityCount > 0 ? '' : 'disabled'">
                <a (click)="summaryClick('Water, Fuel and Power')">
                  <span class="arrow"><i class="fa fa-arrow-right"></i></span>
                </a>
              </td>
            </tr>
            <tr *ngIf="costCategoryRights.isConsumableItemsExcludingUtilities"
              >
              <td>
                <a (click)="summaryClick('Consumable Items')">
                  Consumable Items
                </a>
              </td>
              <td > <div class="amount">£ {{ consumableItems | customCurrency : env.CurrencyFormat }} </div></td>
              <td class="action-btn" [ngClass]="expenditureCount.consumableItemsCount > 0 ? '' : 'disabled'">
                <a (click)="summaryClick('Consumable Items')">
                  <span class="arrow"><i class="fa fa-arrow-right"></i></span>
                </a>
              </td>
            </tr>
            <tr *ngIf="costCategoryRights.isPaymentsToClinicalTrialParticipants"
              >
              <td>
                <a (click)="summaryClick('Payments to Clinical Trial Participants')">
                  Payments to Clinical Trial Participants
                </a>
              </td>
              <td > <div class="amount">£ {{ paymentToClinicalTrialParticiant | customCurrency : env.CurrencyFormat }} </div></td>
              <td class="action-btn" [ngClass]="expenditureCount.paymentsToClinicalTrialParticipantsCount > 0 ? '' : 'disabled'">
                <a (click)="summaryClick('Payments to Clinical Trial Participants')">
                  <span class="arrow"><i class="fa fa-arrow-right"></i></span>
                </a>
              </td>
            </tr>
            <tr>
              <td>
                <a class="total-qualifing">
                  Total
                </a>
              </td>
              <td> <div class="amount total-qualifing">£ {{ total | customCurrency : env.CurrencyFormat }} </div></td>
              <td >

              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </mat-tab>

    <mat-tab label="Staffing" *ngIf="costCategoryRights.isStaffCostClaim">
      <ng-container *ngIf="selectedTab === 'staffing'">
        <app-staff-cost-form></app-staff-cost-form>
      </ng-container>
    </mat-tab>
    <mat-tab label="Externally Provided Workers - Unconnected" *ngIf="costCategoryRights.isUnconnectedContractorPerson">
      <ng-container *ngIf="selectedTab === 'externallyprovidedworkers-unconnected'">
        <app-epw-costs-by-project-form></app-epw-costs-by-project-form>
      </ng-container>
    </mat-tab>
    <mat-tab label="Externally Provided Workers - Connected" *ngIf="costCategoryRights.isConnectedContractorPerson">
      <ng-container *ngIf="selectedTab === 'externallyprovidedworkers-connected'">
        <app-connected-epw-by-project-form></app-connected-epw-by-project-form>
      </ng-container>
    </mat-tab>
    <mat-tab label="Contracted Out R&D - Unconnected" *ngIf="costCategoryRights.isUnconnectedRADContracted">
      <ng-container *ngIf="selectedTab === 'contractedoutr&d-unconnected'">
        <app-sub-contractor-form></app-sub-contractor-form>
      </ng-container>
    </mat-tab>
    <mat-tab label="Contracted Out R&D - Connected" *ngIf="costCategoryRights.isConnectedRADContracted">
      <ng-container *ngIf="selectedTab === 'contractedoutr&d-connected'">
        <app-contractor-form></app-contractor-form>
      </ng-container>
    </mat-tab>
    <mat-tab label="Software" *ngIf="costCategoryRights.isSoftwareLicence">
      <ng-container *ngIf="selectedTab === 'software'">
        <app-software-project-form></app-software-project-form>
      </ng-container>
    </mat-tab>
    <mat-tab label="Data Licences" *ngIf="costCategoryRights.isDataLicence">
      <ng-container *ngIf="selectedTab === 'datalicences'">
        <app-data-licence-form></app-data-licence-form>
      </ng-container>
    </mat-tab>
    <mat-tab label="Cloud Computing" *ngIf="costCategoryRights.isCloudComputing">
      <ng-container *ngIf="selectedTab === 'cloudcomputing'">
        <app-cloud-computing-form></app-cloud-computing-form>
      </ng-container>
    </mat-tab>
    <mat-tab label="Water, Fuel and Power" *ngIf="costCategoryRights.isUtility">
      <ng-container *ngIf="selectedTab === 'water,fuelandpower'">
        <app-utility-form [isParentLocked]="isLocked"></app-utility-form>
      </ng-container>
    </mat-tab>
    <mat-tab label="Consumable Items" *ngIf="costCategoryRights.isConsumableItemsExcludingUtilities">
      <ng-container *ngIf="selectedTab === 'consumableitems'">
        <app-material-consumable-form></app-material-consumable-form>
      </ng-container>
    </mat-tab>
    <mat-tab label="Payments to Clinical Trial Participants"
      *ngIf="costCategoryRights.isPaymentsToClinicalTrialParticipants">
      <ng-container *ngIf="selectedTab === 'paymentstoclinicaltrialparticipants'">
        <app-payments-to-clinical-trial-participants-form></app-payments-to-clinical-trial-participants-form>
      </ng-container>
    </mat-tab>
  </mat-tab-group>
  } @else {
  <div class="main_norecord">
    <h3 class="text-center mt-5 align-content-center">
      No qualifying expenditure by cost category record found.
    </h3>
    <button class="btn btn-primary btn_style_one" type="button" (click)="goCompanyInfo()">
      Go to company Information & Financials Page
    </button>
  </div>
  }
</div>
